export default __webpack_public_path__ + "static/media/coin.c4faa21b.png";